import React, { useEffect, useRef } from "react";

const AudioModal = ({
  showAudioModal,

  currentAudioUrl,

  onClose,

  userAnswers,
}) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (
      showAudioModal &&
      currentAudioUrl?.type === "audio" &&
      audioRef.current
    ) {
      const audioElement = audioRef.current;

      audioElement.pause();

      audioElement.load();
    }
  }, [showAudioModal, currentAudioUrl]);

  if (!showAudioModal || !currentAudioUrl) {
    return null;
  }

  const isAudio = currentAudioUrl.type === "audio";

  const isImage = currentAudioUrl.type === "image";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <h3>{isImage ? "Solution" : "Explanation Audio"}</h3>

        {/* AUDIO */}

        {isAudio && (
          <audio
            ref={audioRef}
            key={currentAudioUrl.url}
            controls
            autoPlay
            controlsList="nodownload noplaybackrate"
          >
            <source src={currentAudioUrl.url} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        )}

        {/* SOLUTION IMAGE */}

        {isImage && (
          <img
            src={currentAudioUrl.url}
            alt="Solution"
            style={{
              display: "block",

              maxWidth: "100%",

              maxHeight: "70vh",

              margin: "0 auto",

              objectFit: "contain",

              borderRadius: "8px",
            }}
          />
        )}

        <button className="btn close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default AudioModal;
